import AppStore from '@stores/AppStore'
import UUID from 'node-uuid'
import Store from 'store'
import utf8 from 'utf8'
import md5 from '../common/sdk/md5'
import { apiConstants } from '@const/apiConstants'

const appDevicePlatform = apiConstants.STR_OS

// 生产环境的参数配置
const appKey = {
  test: 'com.pingan.zhiniao',
  pro: 'ERZF2pSLHBxyZE6t',
}

export const getParamsWithAuth = (
  url: string | undefined,
  data: any = {},
  contentType: string,
  fileRequestParams: any = {},
  isSaas: any
) => {
  const urlParams = getURLParams(url)
  const extraParams = getExtraParams()
  const isJson = contentType.indexOf('application/json') > -1
  const isUploadFile = contentType.indexOf('multipart/form-data') > -1
  const params =
    isUploadFile || isJson ? { ...urlParams, ...fileRequestParams } : { ...urlParams, ...data }
  const keys = Object.keys(params)
  keys.sort()

  let str =
    getBaseKey() + appDevicePlatform + extraParams.nonce + extraParams.timestamp
  keys.map(key => {
    let value = ''
    if (Array.isArray(params[key])) {
      params[key].map((item: any) => {
        const itemStr =
          item === null || item === undefined ? '' : JSON.stringify(item)
        value = value + itemStr
      })
      str = str + key + value
    } else {
      value =
        params[key] === null || params[key] === undefined ? '' : params[key]
      const paramsKey =
        params[key] === null || params[key] === undefined ? '' : key
      str = str + paramsKey + value
    }
  })
  const encodeStr = utf8.encode(str)
  const sign = md5(encodeStr)
  const header = {
    appId: 'com.mlearning.guangqichuanqi',
    nonce: extraParams.nonce,
    sign,
    timestamp: extraParams.timestamp,
    appDevicePlatform,
  }
  const headerMap = JSON.stringify(header)
  return headerMap
}

const getURLParams = (url: string | undefined): any => {
  if (typeof url === 'string') {
    const urlInfos = url.split('?')

    if (urlInfos.length === 1) {
      return {}
    }

    const paramString = urlInfos[1].split('&')
    const result = {}
    paramString.map(param => {
      const paramArr = param.split('=')
      result[paramArr[0]] = decodeURI(paramArr[1])
    })

    return result
  }
  return {}
}

const getExtraParams = () => {
  const nonceStr = UUID()
  const nonce = md5(nonceStr)
  const localTimeGap = Store.get('timeGap')
  const timeGap = AppStore.timeGap || localTimeGap
  const timestamp = Date.now() - timeGap || 0
  return {
    nonce,
    timestamp,
  }
}

// 	获取加密key
const getBaseKey = () => {
  const isTestDev =
    window.location.host.indexOf('gq-api.zhi-niao.com') > -1 ||
    window.location.host.indexOf('gq-h5.zhi-niao.com') > -1 ||
    window.location.host.indexOf('test') > -1 ||
    window.location.host.indexOf('localhost') > -1 ||
    window.location.host.indexOf('127.0.0.1') > -1
    // window.location.host.indexOf('gacmotor') > -1
  return isTestDev ? appKey.test : appKey.pro
}
